import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { UAParser } from 'ua-parser-js';
import { useEditor } from '../../hooks/useEditor';
import { TextAreaInput } from '../common/inputs/TextAreaInput';
import { SelectInput } from '../common/inputs/selectInput/SelectInput';

export const Feedback = ({
  setFeedbackMessage,
}: {
  setFeedbackMessage: (message: string) => void;
}) => {
  const {
    userSession: { email, planName, paymentModel },
    launcherThemeSession: { themeID, versionID },
  } = useEditor();
  const [issueType, setIssuseType] = useState<'bug' | 'feature'>('bug');
  const [description, setDescription] = useState('');
  const [steps, setSteps] = useState('');

  useEffect(() => {
    const header =
      issueType === 'bug' ? `# [ ${issueType} ]` : `## [ ${issueType} ]`;
    const userInfo = `**${email}** | ${planName} | ${paymentModel}`;
    const themeInfo = `\`${themeID}\` | \`${versionID}\``;
    const parser = new UAParser(navigator.userAgent);
    const parserResults = parser.getResult();
    const browserInfo = `${parserResults.browser.name} ${parserResults.browser.version}`;
    const systemInfo = `${parserResults.os.name} ${parserResults.os.version}`;

    setFeedbackMessage(
      `
${header}
${userInfo}
${themeInfo}
${systemInfo} | ${browserInfo}

${description}

${steps ? 'Steps to reproduce: ' : ''}
${steps}
`
    );
  }, [issueType, description, steps]);

  return (
    <Container>
      <SelectInputContainer $issueType={issueType}>
        <SelectInput
          id="issue-type-select-input"
          label="Issue type"
          value={issueType}
          onChange={setIssuseType}
          options={[
            { value: 'bug', label: 'Bug' },
            { value: 'feature', label: 'Feature' },
          ]}
        />
      </SelectInputContainer>

      <TextAreaInput
        id="issue-description-textarea-input"
        label="Description"
        placeholder="Describe your issue"
        value={description}
        onChange={(newValue) => setDescription(newValue)}
        rows={15}
        column
      />

      {issueType === 'bug' && (
        <TextAreaInput
          id="issue-steps-textarea-input"
          label="Steps to reproduce"
          placeholder="Describe the steps to reproduce the issue"
          value={steps}
          onChange={(newValue) => setSteps(newValue)}
          rows={10}
          column
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SelectInputContainer = styled.div<{ $issueType?: 'bug' | 'feature' }>`
  ${({ $issueType }) =>
    $issueType === 'bug' &&
    `
      .react-select-container {
        border: 1px solid var(--error-color);
      }
    `}
  ${({ $issueType }) =>
    $issueType === 'feature' &&
    `
      .react-select-container {
        border: 1px solid var(--info-color);
      }
    `}
`;
